import React, { useState, Component } from "react";
import styled from "styled-components";
import { Row, Col, Form, Input, Button, Modal, Select } from "antd";
import { Link } from "react-router-dom";
import Fade from "react-reveal/Fade";
import { data } from "jquery";
import './form.css';
import "antd/dist/antd.css";


//import { Modal as SuccessModal } from "react-responsive-modal";
//import "react-responsive-modal/styles.css";

const { Option } = Select;
const { TextArea } = Input;
const selectBefore = (
  <Form.Item
    name='title'
    rules={[{ required: true, message: false }]}
    style={{ marginBottom: "0px" }}
  >
    <Select placeholder='Title' className='select-before'>
      <Option value='Mrs'>Mr</Option>
      <Option value='Miss'>Miss</Option>
    </Select>
  </Form.Item>
);
const StyledInput = styled(Input)`
  .ant-input-affix-wrapper > .ant-input {
    color: white !important;
    width: 100% !important;
  }
  .ant-input-affix-wrapper {
    color: white !important;
    width: 100% !important;
    animation: gradientBorder 8s linear infinite;
  }

  @keyframes gradientBorder {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }

  .ant-input {
    transition: 0s !important;
  }

  .ant-input-affix-wrapper::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background: linear-gradient(to right, #61bc08, #274905, #61bc08);
    background-size: 200% 100%;
    animation: gradientBorder 8s linear infinite;
  }

  .ant-input::placeholder {
    color: rgb(171, 171, 171) !important;
    font-family: 'Roboto';
  }

  .ant-input-affix-wrapper > .ant-input {
    font-size: inherit;
    border: none;
    background: #151515 !important;
    outline: none;
  }

  textarea.ant-input {
    border-bottom: 2px solid #61bc08 !important;
  }

  .ant-input {
    font-family: 'Roboto';
  }

  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  @keyframes move {
    0%,
    100% {
      transform: translate(calc(50vw + 50%), calc(-50vh + 50%)) scale(1);
    }
    25% {
      transform: translate(calc(50vw + 50%), calc(50vh + 50%)) scale(0.8);
    }
    50% {
      transform: translate(calc(-10vw - 50%), calc(-50vh + 50%)) scale(1.5);
    }
    75% {
      transform: translate(calc(-10vw - 50%), calc(50vh - 50%)) scale(0.8);
    }
  }

  .gradient {
    position: absolute;
    --size: 250px;
    --speed: 50s;
    --easing: cubic-bezier(0.8, 0.2, 0.2, 0.8);
    width: var(--size);
    height: var(--size);
    filter: blur(calc(var(--size) / 5));
    background-image: linear-gradient(#62bc087b, #0f0f0f);
    animation: rotate 100s linear infinite, move 100s linear infinite;
    border-radius: 30% 70% 70% 30%/30% 30% 70% 70%;
  }

  @media (min-width: 720px) {
    .gradient {
      --size: 500px;
    }
  }
`;

class ContactUss extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };

    this.onFinish = this.onFinish.bind(this);
  }
  componentDidMount() {
    document.documentElement.scrollTop = 0;
  }
  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
    window.location.assign("./");
  };

  handleCancel = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
    window.location.assign("./");
  };
  handleSubmit = (values) => {
    this.onFinish(values);
  };
  //onFinish = (values) => {
  //  (async () => {
  //    const rawResponse = await fetch(
  //      "https://leadsv3.cmscloud.co.za/api/lead/saveleadasync",
  //      {
  //        method: "POST",
  //        headers: {
  //          Accept: "application/json",
  //          "Content-Type": "application/json",
  //          Authorization: "Bearer " + "9D20B459-5A85-45C4-92B4-7D0F7E7FA50B",
  //        },
  //        body: JSON.stringify({
  //          //title: "React POST Request Example",
  //          lead: {
  //            dealerRef: "MT001",
  //            dealerFloor: "USED",
  //            //dealerSalesPerson: "",
  //            //region: "Gauteng",
  //            source: "MT-DEALERWEBSITE",
  //            transactionID: data.id,
  //            //details: values.details,
  //          },
  //          contact: {
  //            email: values.email,
  //            cellPhone: values.cellPhone,
  //            surname: values.surname,
  //            firstName: values.firstName,
  //            title: values.title,
  //          },
  //          //referrer: {
  //          //  email: values.email,
  //          //  cellPhone: values.cellPhone,
  //          //  surname: values.surname,
  //          //  firstName: values.firstName,
  //          //  title: values.title,
  //          //},
  //        }),
  //      }
  //    );
  //    const content = await rawResponse.json();

  //    console.log(content);
  //  })();
  //};
  //onFinish = (values) => {
  //  // Simple POST request with a JSON body using fetch
  //  const requestOptions = {
  //    method: "POST",
  //    headers: {
  //      "Content-Type": "application/json",
  //      Authorization: "Bearer " + "9D20B459-5A85-45C4-92B4-7D0F7E7FA50B",
  //    },
  //    body: JSON.stringify({
  //      //title: "React POST Request Example",
  //      lead: {
  //        dealerRef: "MT001",
  //        dealerFloor: "USED",
  //        //dealerSalesPerson: "",
  //        //region: "Gauteng",
  //        source: "MT-DEALERWEBSITE",
  //        transactionID: data.id,
  //        //details: values.details,
  //      },
  //      contact: {
  //        email: values.email,
  //        cellPhone: values.cellPhone,
  //        surname: values.surname,
  //        firstName: values.firstName,
  //        title: values.title,
  //      },
  //      //referrer: {
  //      //  email: values.email,
  //      //  cellPhone: values.cellPhone,
  //      //  surname: values.surname,
  //      //  firstName: values.firstName,
  //      //  title: values.title,
  //      //},
  //    }),
  //  };
  //  fetch(
  //    "https://aws-stage-leadsv3.cmscloud.co.za/api/lead/savelead",
  //    requestOptions
  //  )
  //    .then((response) => response.json())
  //    .then(async (res) => {
  //      if (!res.ok) {
  //        console.log("handle error");
  //        this.setState({
  //          code: "01",
  //          leadReference: "",
  //          status: "Failed",
  //          message: "Rejected - Lead DealerRef Invalid: 123M",
  //        });
  //      }
  //      console.log("handle success");
  //      this.setState({
  //        visible: true,
  //        submitDisabled: true,
  //        code: "00",
  //        leadReference: "fe7521e8-d48e-420d-a8d5-c9821a267a7c",
  //        status: "Success",
  //        message: "",
  //      });
  //    });
  //};
  onFinish = (values) => {
    const MSG = {
      to: [
        "leads@megatheron.co.za",
        //"ianels182@gmail.com",
        //"allan@megatheron.co.za",
        //"xander@megatheron.co.za",
      ],
      from: "info@mtgroup.co.za",
      subject: "Jolion Pro Test Drive",
      text: " ",
      html: `
    
      <style type="text/css">  
      body, #bodyTable{background-color:white}
      #emailHeader{background-color:white}
      #emailBody{background-color:#FFFFFF; border:1px solid #CCCCCC;}
      #emailFooter{background-color:#E1E1E1;}      
</style>
<body bgcolor="#E1E1E1" leftmargin="0" marginwidth="0" topmargin="0" marginheight="0" offset="0">
<center style="background-color:#E1E1E1;">
<table border="0" cellpadding="0" cellspacing="0" height="100%" width="100%" id="bodyTable" style="table-layout: fixed;max-width:100% !important;width: 100% !important;min-width: 100% !important;">
  <tr>
    <td align="center" valign="top" id="bodyCell">      
      <table bgcolor="#E1E1E1" border="0" cellpadding="0" cellspacing="0" width="500" id="emailHeader">
        <!-- HEADER ROW // -->
        <tr>
          <td align="center" valign="top">
            <!-- CENTERING TABLE // -->
            <table border="0" cellpadding="0" cellspacing="0" width="100%">
              <tr>
                <td align="center" valign="top">
                  <!-- FLEXIBLE CONTAINER // -->
                  <table border="0" cellpadding="10" cellspacing="0" width="500" class="flexibleContainer">
                    <tr>
                      <td valign="top" width="500" class="flexibleContainerCell">

                        <!-- CONTENT TABLE // -->
                        <table align="left" border="0" cellpadding="0" cellspacing="0" width="100%">
                          <tr>
                       
                            <td align="right" valign="middle" class="flexibleContainerBox">
                              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:100%;">
                                <tr>
                                  <td align="left" class="textContent">
                                    <!-- CONTENT // -->
                                   
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                  <!-- // FLEXIBLE CONTAINER -->
                </td>
              </tr>
            </table>
            <!-- // CENTERING TABLE -->
          </td>
        </tr>
        <!-- // END -->
      </table>     
      <!-- EMAIL BODY // -->   
      <table bgcolor="#FFFFFF" border="0" cellpadding="0" cellspacing="0" width="500" id="emailBody">
        <!-- MODULE ROW // -->
        <tr>
          <td align="center" valign="top">
            <!-- CENTERING TABLE // -->
            <table border="0" cellpadding="0" cellspacing="0"   style="color:#FFFFFF;" bgcolor="#101010">
              <tr>
                <td align="center" valign="top">
                  <!-- FLEXIBLE CONTAINER // -->
                 
                  <table border="0" cellpadding="0" cellspacing="0" width="500"   class="flexibleContainer">
                    <tr>
                      <td align="center" valign="top" width="500" class="flexibleContainerCell">

                        <!-- CONTENT TABLE // -->
                      
                        <table border="0" cellpadding="0" cellspacing="0" width="100%" z-index="100" >
                               <td align="center" valign="top" width="500" class="flexibleContainerCell  ">   
                                <img alt="" src="https://i.ibb.co/z5SfxC9/mtgroup.png" width="300" height="85" style="display: block; border-radius: 8px 8px 8px 8px; font-family: Lato, Helvetica, Arial, sans-serif; color: #9AA31E; font-size: 18px;margin-top: 18px;" border="0">     <tr>
                            <td align="center" valign="top" class="textContent">
                              <h1 style="color:white;line-height:100%;font-family:Helvetica,Arial,sans-serif;font-size:35px;font-weight:normal;margin-bottom:20px;text-align:center;">Jolion Pro Test Drive Enquiry</h1>
                              <h2 style="text-align:center;font-weight:normal;font-family:Helvetica,Arial,sans-serif;font-size:17px;margin-bottom:10px;color: white;line-height:135%;">You have received a new Jolion Pro Test Drive Enquiry from <br /> Mega Theron Group website</h2>
                            </td>
                          </tr>
                        </table>
                        <!-- // CONTENT TABLE -->
                      </td>
                    </tr>
                  </table>
                  <!-- // FLEXIBLE CONTAINER -->
                </td>
              </tr>
            </table>
            <!-- // CENTERING TABLE -->
          </td>
        </tr>
        <!-- MODULE ROW // -->
        <tr mc:hideable>
          <td align="center" valign="top">
            <!-- CENTERING TABLE // -->
            <table border="0" cellpadding="0" cellspacing="0" width="100%" height="300" >
              <tr>
                <td align="center" valign="top">
                  <!-- FLEXIBLE CONTAINER // -->
                  <table border="0" cellpadding="0" cellspacing="0" width="300" class="flexibleContainer">
                    <tr>
                      <td valign="top" width="500" class="flexibleContainerCell">
                        <!-- CONTENT TABLE // -->
                        <table p align="left" border="0" cellpadding="0" cellspacing="0" width="120%">
                          <tr>
                            <td align="center" valign="top" class="flexibleContainerBox">
                               <table border="0" cellspacing="0" cellpadding="0" >
            
                        <tr style="font-family: sans-serif; font-size: 17px; letter-spacing: 1px; color:black">
                          <td class="role"><br />
                          <strong> Name </strong> &nbsp;&nbsp;:&nbsp;&nbsp; ${values.nameContact} ${values.surname}<br />
                          <strong> Number </strong> &nbsp;&nbsp;:&nbsp;&nbsp; ${values.numberContact}<br />
                          <strong> Email </strong> &nbsp;&nbsp;:&nbsp;&nbsp; ${values.emailContact}<br />
                            <strong> Branch </strong> &nbsp;&nbsp;:&nbsp;&nbsp; ${values.serviceContact}<br />

                 
                      
                       
                             <br /><br />
                          </td>
                        </tr>
                        <table>
                            </td>
                          </tr>
                        </table>
                        <!-- // CONTENT TABLE -->

                      </td>
                    </tr>
                  </table>
                  <!-- // FLEXIBLE CONTAINER -->
                </td>
              </tr>
            </table>
            <!-- // CENTERING TABLE -->
          </td>
        </tr>
        <!-- // MODULE ROW -->


        <!-- MODULE ROW // -->
       
<table border="0" cellpadding="0" cellspacing="0" width="100%"  style="color:#FFFFFF;" bgcolor="#101010" style="text-align:center;font-weight:normal;font-family:Helvetica,Arial,sans-serif;font-size:13px;margin-bottom:-80px;color: lightgray;line-height:135%;">
              <tr>
                <td align="center" valign="top">
                
                  <table border="0" cellpadding="0" cellspacing="0" width="500"   class="flexibleContainer">
                    <tr>
                      <td align="center" valign="top" width="500" class="flexibleContainerCell">

                    
                        <table border="0" cellpadding="30" cellspacing="0" width="100%">
                      
                    
                          <tr>
                            <td align="center" valign="top" class="textContent">
        
                              <h2 style="text-align:center;font-weight:normal;font-family:Helvetica,Arial,sans-serif;font-size:13px;margin-bottom:0px;color: grey;line-height:135%;">2024@Mega Theron Group</h2>
               
                            </td>
                          </tr>
                        </table>
                        <!-- // CONTENT TABLE -->

                      </td>
                    </tr>
                  </table>
                  <!-- // FLEXIBLE CONTAINER -->
                </td>
              </tr>
            </table>
     `,
    };
    fetch("https://www.vcsappcloud.com/emailclient/sendmail", {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      body: JSON.stringify(MSG),
    }).then(async (res) => {
      if (!res.ok) {
        console.log("handle error");
      }
      console.log("handle success");
      this.setState({
        visible: true,
        submitDisabled: true,
        title: "",
        firstName: "",
        surname: "",
        cellPhone: "",
        email: "",
      });
    });
  };
  //onFinish = (values) => {
  //  let api_url_stage =
  //    "https://aws-stage-leadsv3.cmscloud.co.za/api/lead/savelead";
  //  let api_token_stage = "9D20B459-5A85-45C4-92B4-7D0F7E7FA50B";
  //  let api_url_prod = "https://leadsv3.cmscloud.co.za/api/lead/savelead";
  //  let api_token_prod = "B9CDC074-49D8-401F-81BB-4DE4F6B83CA1";
  //  // POST request using fetch with set headers
  //  const requestOptions = {
  //    method: "POST",
  //    headers: {
  //      "Content-Type": "application/json",
  //      Authorization: api_token_stage,
  //    },
  //    body: JSON.stringify({
  //      lead: {
  //        dealerRef: "MT001",
  //        dealerFloor: "USED",
  //        source: "MT-DEALERWEBSITE",
  //        //transactionID: data.id,
  //      },
  //      contact: {
  //        email: values.email,
  //        cellPhone: values.cellPhone,
  //        surname: values.surname,
  //        firstName: values.firstName,
  //        title: values.title,
  //      },
  //    }),
  //  };
  //  fetch(api_url_stage, requestOptions)
  //    .then((response) => response.json())
  //    .then((res) => {
  //      // Unfortunately, fetch doesn't send (404 error) into the cache itself
  //      // You have to send it, as I have done below
  //      if (res.status >= 400) {
  //        throw new Error("Server responds with error!");
  //      }
  //      return res.json();
  //    })
  //    .then(() =>
  //      this.setState({
  //        code: "00",
  //        leadReference: "fe7521e8-d48e-420d-a8d5-c9821a267a7c",
  //        status: "Success",
  //        message: "",
  //      })
  //    );
  //  (err) => {
  //    this.setState({
  //      err,
  //      code: "01",
  //      leadReference: "",
  //      status: "Failed",
  //      message: "Rejected - Lead DealerRef Invalid: 123M",
  //    });
  //  };
  //};
  render() {
    return (
      <div>
        <div style={{ background: "black", height: "100vh" }} className='desktop-view'>
          {/* <img
          //className="banner-img-home"
          style={{
            width: "106vw",
            position: "absolute",
            height: "35em",
            objectFit: "cover",
            top: 0,
            right: 0,
            zIndex: 0,
            opacity: 0.5,
          }}
          src={`${process.env.PUBLIC_URL}/images/header-banner.png`}
          alt='logo'
        /> */}

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100vh',
              backgroundColor: 'black', // You can change this background color if needed
              maxWidth: "110em",
              margin: "auto"
            }}
          >
            <Row gutter={12} style={{
              justifyContent: 'center',
              alignItems: 'center',
            }}>
              <Col
                xs={0} md={1}></Col>
              <Col xs={24} md={0} className="flicker-animation">
                <Fade delay={1500} cascade >
                  <img
                    style={{ width: '100%', height: '100%' }}
                    src={`${process.env.PUBLIC_URL}/images/jolion-pro.jpg`}
                    alt='logo'
                  />
                </Fade>
              </Col>
              <Col
                xs={24} md={7}
                style={{

                  // background: 'lightgrey',
                  textAlign: 'center',
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: '20px',
                  borderRadius: '10px',
                  margin: "auto"
                }}
              >
                <Fade delay={800}>
                  <h2 style={{ color: 'white', marginTop: '0em', marginBottom: "-0.5em", padding: 0, fontSize: "30px" }}>Next-level is here</h2>
                </Fade>
                <Fade delay={800}>
                  <h4 style={{ color: 'white', marginBottom: "-1em", }} className='f-weight-300'>
                    <strong>Register Now</strong>
                  </h4>
                  <h4 style={{ color: 'white', marginBottom: "-1em", fontSize: "15px", whiteSpace: "normal", lineHeight: "1.2em" }} className='f-weight-300'>
                    Don’t miss this unique opportunity to be among the first to experience the next level of driving with the Haval Jolion Pro
                  </h4>
                  <h4 style={{ color: 'white', marginBottom: "1em", fontSize: "12px" }} className='f-weight-300'>

                    <strong> Fill out the form below to secure your spot for a test drive.</strong>
                  </h4>
                </Fade>
                {/* <p style={{ color: 'white', margin: 'auto', padding: 0 }}>Let us call you back</p> */}

                <Form
                  onFinish={this.handleSubmit}
                  initialValues={{ remember: true }}
                  name='wrap'
                  labelCol={{ flex: '110px' }}
                  labelAlign='left'
                  labelWrap
                  wrapperCol={{ flex: 1 }}
                  colon={false}
                >
                  <Row gutter={24}>

                    <Col xs={24} md={24}>
                      <Fade delay={100} bottom cascade>
                        <Form.Item
                          style={{ width: "100%", }}
                          hasFeedback
                          name="nameContact"
                          rules={[{ required: true, message: 'Please enter your name' }]}
                        >
                          <StyledInput
                            placeholder={"First Name"}
                            style={{
                              width: "100%",
                              color: 'white',
                              height: '45px',
                              paddingLeft: '1.2em',
                              border: 'none',
                              backgroundColor: '#151515',
                              borderRadius: '0.3em'
                            }}
                          />
                        </Form.Item>
                      </Fade>
                    </Col>

                    <Col xs={24} md={24}>
                      <Fade delay={200} bottom cascade>
                        <Form.Item
                          hasFeedback
                          name="surname"
                          rules={[{ required: true, message: 'Please enter your surname' }]}
                        >
                          <Input
                            placeholder={"Surname"}
                            style={{
                              color: 'white',
                              height: '45px',
                              paddingLeft: '1.2em',
                              border: 'none',
                              backgroundColor: '#151515',
                              borderRadius: '0.3em'
                            }}
                          />

                        </Form.Item>
                      </Fade>
                    </Col>
                    <Col xs={24} md={24}>
                      <Fade delay={300} bottom cascade>
                        <Form.Item
                          hasFeedback
                          name="numberContact"
                          rules={[
                            { required: true, message: 'Please enter a contact number.' },
                            { min: 10, max: 10, message: 'Contact number must be 10 characters.' },
                            { pattern: /^[0-9]+$/, message: 'Contact number must contain only numbers.' }
                          ]}
                        >
                          <Input
                            placeholder={"Contact Number"}
                            style={{
                              color: 'white',
                              height: '45px',
                              paddingLeft: '1.2em',
                              border: 'none',
                              backgroundColor: '#151515',
                              borderRadius: '0.3em'
                            }}
                          />
                        </Form.Item>
                      </Fade>
                    </Col>
                    <Col xs={24} md={24}>
                      <Fade delay={400} bottom cascade>
                        <Form.Item
                          hasFeedback
                          name="emailContact"
                          rules={[
                            { type: 'email', required: true, message: 'Please enter valid email' }
                          ]}
                        >
                          <Input
                            placeholder={"Your Email"}
                            style={{
                              color: 'white',
                              height: '45px',
                              paddingLeft: '1.2em',
                              border: 'none',
                              backgroundColor: '#151515',
                              borderRadius: '0.3em'
                            }}
                          />
                        </Form.Item>
                      </Fade>
                    </Col>
                    <Col xs={24} md={24}>
                      <Fade delay={500} bottom cascade>
                        <Form.Item
                          hasFeedback
                          name="serviceContact"
                          rules={[
                            { required: true, message: 'Please select an option' }
                          ]}
                        >
                          <Select
                            placeholder={"Branch"}
                            style={{
                              paddingTop: '0.4em',
                              border: 'none',
                              backgroundColor: '#151515',
                              borderRadius: '0.3em',
                              textAlign: 'left'
                            }}
                            options={[
                              { value: ' Klerksdorp', label: 'Klerksdorp' },
                              { value: ' Potchefstroom', label: 'Potchefstroom' },
                              { value: ' Lichtenburg', label: 'Lichtenburg' },
                              { value: ' Mahikeng', label: 'Mahikeng' },
                            ]}
                          />
                        </Form.Item>
                      </Fade>
                    </Col>
                    <Col xs={24} md={24}>
                      <Fade delay={500} left cascade >
                        <Form.Item>
                          <Button
                            htmlType="submit"
                            type="primary"
                            className="mainBtn1"
                            // disabled={submitDisabledContact}
                            style={{
                              marginTop: "0em",
                              float: "right",
                              width: "9em"
                            }}
                          >
                            Book Now
                            <span>
                              {/* <RocketFilled /> */}
                            </span>
                          </Button>
                        </Form.Item>
                      </Fade>
                    </Col>
                  </Row>
                </Form>

              </Col>
              <Col xs={0} md={14} className="flicker-animation">
                <Fade delay={1500} cascade >
                  <img
                    style={{ width: '100%', height: '100%' }}
                    src={`${process.env.PUBLIC_URL}/images/jolion-pro.jpg`}
                    alt='logo'
                  />
                </Fade>
              </Col>
            </Row>
          </div>
        </div >
        <div style={{ background: "black", }} className='mobile-view'>
          {/* <img
          //className="banner-img-home"
          style={{
            width: "106vw",
            position: "absolute",
            height: "35em",
            objectFit: "cover",
            top: 0,
            right: 0,
            zIndex: 0,
            opacity: 0.5,
          }}
          src={`${process.env.PUBLIC_URL}/images/header-banner.png`}
          alt='logo'
        /> */}

          <div
            style={{

              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100vh',
              backgroundColor: 'black', // You can change this background color if needed
              maxWidth: "110em",
              margin: "auto"

            }}
          >
            <Row gutter={12} style={{
              justifyContent: 'center',
              alignItems: 'center',
            }}>
              <Col
                xs={0} md={1}></Col>
              <Col xs={24} md={0} className="flicker-animation">
                <Fade delay={1500} cascade >
                  <img
                    style={{ width: '100%', height: '100%', marginTop: "11em" }}
                    src={`${process.env.PUBLIC_URL}/images/jolion-pro-mobile.png`}
                    alt='logo'
                  />
                </Fade>
              </Col>
              <Col
                xs={24} md={7}
                style={{

                  // background: 'lightgrey',
                  textAlign: 'center',
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: '20px',
                  borderRadius: '10px',
                  margin: "auto"
                }}
              >
                <Fade delay={800}>
                  <h2 style={{ color: 'white', marginTop: '0em', marginBottom: "-0.5em", padding: 0, fontSize: "30px" }}>Next-level is here</h2>
                </Fade>
                <Fade delay={800}>
                  <h4 style={{ color: 'white', marginBottom: "-1em", }} className='f-weight-300'>
                    <strong>Register Now</strong>
                  </h4>
                  <h4 style={{ color: 'white', marginBottom: "-1em", fontSize: "15px", whiteSpace: "normal", lineHeight: "1.2em" }} className='f-weight-300'>
                    Don’t miss this unique opportunity to be among the first to experience the next level of driving with the Haval Jolion Pro
                  </h4>
                  <h4 style={{ color: 'white', marginBottom: "1em", fontSize: "12px" }} className='f-weight-300'>

                    <strong> Fill out the form below to secure your spot for a test drive.</strong>
                  </h4>
                </Fade>
                {/* <p style={{ color: 'white', margin: 'auto', padding: 0 }}>Let us call you back</p> */}

                <Form
                  onFinish={this.handleSubmit}
                  initialValues={{ remember: true }}
                  name='wrap'
                  labelCol={{ flex: '110px' }}
                  labelAlign='left'
                  labelWrap
                  wrapperCol={{ flex: 1 }}
                  colon={false}
                >
                  <Row gutter={24}>

                    <Col xs={24} md={24}>
                      <Fade delay={100} bottom cascade>
                        <Form.Item
                          style={{ width: "100%", marginBottom: "1.2em" }}
                          hasFeedback
                          name="nameContact"
                          rules={[{ required: true, message: 'Please enter your name' }]}
                        >
                          <StyledInput
                            placeholder={"First Name"}
                            style={{
                              width: "100%",
                              color: 'white',
                              height: '45px',
                              paddingLeft: '1.2em',
                              border: 'none',
                              backgroundColor: '#151515',
                              borderRadius: '0.3em'
                            }}
                          />
                        </Form.Item>
                      </Fade>
                    </Col>

                    <Col xs={24} md={24}>
                      <Fade delay={200} bottom cascade>
                        <Form.Item
                          style={{ width: "100%", marginBottom: "1.2em" }}
                          hasFeedback
                          name="surname"
                          rules={[{ required: true, message: 'Please enter your surname' }]}
                        >
                          <Input
                            placeholder={"Surname"}
                            style={{
                              color: 'white',
                              height: '45px',
                              paddingLeft: '1.2em',
                              border: 'none',
                              backgroundColor: '#151515',
                              borderRadius: '0.3em'
                            }}
                          />

                        </Form.Item>
                      </Fade>
                    </Col>
                    <Col xs={24} md={24}>
                      <Fade delay={300} bottom cascade>
                        <Form.Item
                          style={{ width: "100%", marginBottom: "1.2em" }}
                          hasFeedback
                          name="numberContact"
                          rules={[
                            { required: true, message: 'Please enter a contact number.' },
                            { min: 10, max: 10, message: 'Contact number must be 10 characters.' },
                            { pattern: /^[0-9]+$/, message: 'Contact number must contain only numbers.' }
                          ]}
                        >
                          <Input
                            placeholder={"Contact Number"}
                            style={{
                              color: 'white',
                              height: '45px',
                              paddingLeft: '1.2em',
                              border: 'none',
                              backgroundColor: '#151515',
                              borderRadius: '0.3em'
                            }}
                          />
                        </Form.Item>
                      </Fade>
                    </Col>
                    <Col xs={24} md={24}>
                      <Fade delay={400} bottom cascade>
                        <Form.Item
                          style={{ width: "100%", marginBottom: "1.2em" }}
                          hasFeedback
                          name="emailContact"
                          rules={[
                            { type: 'email', required: true, message: 'Please enter valid email' }
                          ]}
                        >
                          <Input
                            placeholder={"Your Email"}
                            style={{
                              color: 'white',
                              height: '45px',
                              paddingLeft: '1.2em',
                              border: 'none',
                              backgroundColor: '#151515',
                              borderRadius: '0.3em'
                            }}
                          />
                        </Form.Item>
                      </Fade>
                    </Col>
                    <Col xs={24} md={24}>
                      <Fade delay={500} bottom cascade>
                        <Form.Item
                          style={{ width: "100%", marginBottom: "1.2em" }}
                          hasFeedback
                          name="serviceContact"
                          rules={[
                            { required: true, message: 'Please select an option' }
                          ]}
                        >
                          <Select
                            placeholder={"Branch"}
                            style={{
                              paddingTop: '0.4em',
                              border: 'none',
                              backgroundColor: '#151515',
                              borderRadius: '0.3em',
                              textAlign: 'left'
                            }}
                            options={[
                              { value: ' Klerksdorp', label: 'Klerksdorp' },
                              { value: ' Potchefstroom', label: 'Potchefstroom' },
                              { value: ' Lichtenburg', label: 'Lichtenburg' },
                              { value: ' Mahikeng', label: 'Mahikeng' },
                            ]}
                          />
                        </Form.Item>
                      </Fade>
                    </Col>
                    <Col xs={24} md={24}>
                      <Fade delay={500} left cascade >
                        <Form.Item>
                          <Button
                            htmlType="submit"
                            type="primary"
                            className="mainBtn1"
                            // disabled={submitDisabledContact}
                            style={{
                              margin: "auto",
                              marginTop: "1em",

                              width: "80%"
                            }}
                          >
                            Book Now
                            <span>
                              {/* <RocketFilled /> */}
                            </span>
                          </Button>
                        </Form.Item>
                      </Fade>
                    </Col>
                  </Row>
                </Form>

              </Col>
              <Col xs={0} md={14} className="flicker-animation">
                <Fade delay={1500} cascade >
                  <img
                    style={{ width: '100%', height: '100%' }}
                    src={`${process.env.PUBLIC_URL}/images/jolion-pro.jpg`}
                    alt='logo'
                  />
                </Fade>
              </Col>
            </Row>
          </div>
        </div >

        <Modal
          visible={this.state.visible}
          style={{ textAlign: "center" }}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
        >
          <img
            src={`${process.env.PUBLIC_URL}/images/logo.png`}
            alt='Logo'
            style={{ width: "65%", margin: "auto" }}
          />
          <h3
            style={{
              marginTop: "1em",
              color: "black",
              textAlign: "center",
              fontSize: "20px",
            }}
          >
            Thank you for contacting
            <br />
            <span style={{ color: "rgb(214, 54, 41)" }}>
              The Mega Theron Group.
            </span>{" "}
            <br />
            <br />
            <span style={{ color: "black ", fontSize: "17px" }}>
              Our vehicle specialist will be in touch shortly.
            </span>{" "}
            <br />
          </h3>{" "}
          <br />
        </Modal>

      </div>
    );
  }
}
export default ContactUss;



// WEBPACK FOOTER //
// ./src/components/jolionPro.js